module.exports = __webpack_public_path__ + "static/media/Logo5.b02a80ea.png";